<ca-modal-container
    [modalTitle]="(urlMode === 'ADD' ? 'WORKFLOWS.RUNNER.URL_MODAL.TITLE.ADD_URL' : 'WORKFLOWS.RUNNER.URL_MODAL.TITLE.EDIT_URL') | translate"
    (dismiss)="dismiss()"
>
    <form [formGroup]="formGroup" class="form-validation" (ngSubmit)="submit()" novalidate>
        <div>
            <div class="d-flex flex-column-reverse">
                <input
                    type="url"
                    id="url"
                    class="form-control"
                    formControlName="url"
                    [placeholder]="'WORKFLOWS.RUNNER.URL_MODAL.INPUT_PLACEHOLDER' | translate"
                    required
                    data-uit="url-input"
                    [ngClass]="formGroup.get('url')?.errors && formGroup.get('url')?.dirty ? 'has-error' : ''"
                />
                <label for="url" class="visually-hidden">{{ 'WORKFLOWS.RUNNER.URL_MODAL.INPUT_LABEL' | translate }}</label>
            </div>
            <small *ngIf="formGroup.get('url')?.dirty && formGroup.get('url')?.hasError('required')" class="invalid-feedback">
                {{ 'WORKFLOWS.RUNNER.URL_MODAL.ERROR_MESSAGE.REQUIRED_FIELD' | translate }}
            </small>
            <small
                *ngIf="formGroup.get('url')?.dirty && (formGroup.get('url')?.hasError('pattern') || formGroup.get('url')?.hasError('invalidURI'))"
                class="invalid-feedback"
            >
                {{ 'WORKFLOWS.RUNNER.URL_MODAL.ERROR_MESSAGE.INVALID_URL' | translate }}
            </small>
            <small *ngIf="formGroup.get('url')?.dirty && formGroup.get('url')?.hasError('nameExistsInArray')" class="invalid-feedback">
                {{ 'WORKFLOWS.RUNNER.URL_MODAL.ERROR_MESSAGE.NAME_ALREADY_EXISTS' | translate }}
            </small>
            <small *ngIf="formGroup.get('url')?.dirty && formGroup.get('url')?.hasError('notSupportedFileType')" class="invalid-feedback">
                {{
                    notSupportedFileTypeCustomMessage || 'GENERAL.NOT_SUPPORTED_FILE_TYPE'
                        | translate: { fileName: formGroup.get('url')?.errors.notSupportedFileType.value }
                }}
            </small>
        </div>
        <span class="text-warning" *ngIf="maxFileSizeInBytes">
            {{
                maxFileSizeCustomMessage != null
                    ? maxFileSizeCustomMessage
                    : ('WORKFLOWS.RUNNER.URL_MODAL.FILE_SIZE_WARNING' | translate: { fileSize: maxFileSizeInBytes | fileSize })
            }}
        </span>
        <div class="modal-buttons pb-3">
            <button type="submit" class="btn btn-primary mt-2" caAutoFocus [disabled]="!formGroup.valid || isSubmitting" data-uit="add-url-button">
                <span *ngIf="urlMode === 'ADD'">{{ 'GENERAL.ADD' | translate }}</span>
                <span *ngIf="urlMode === 'EDIT'">{{ 'GENERAL.SAVE' | translate }}</span>
            </button>
        </div>
    </form>
</ca-modal-container>
